/* eslint-disable import/no-anonymous-default-export */
import { api } from '@System/api'

export default {
    getOrderFinance: params => api.get('/merchant/orders/finance', { params, singleRequest: true, loading: false }),
    getOrderStatistic: params => api.get('/merchant/orders/stats', { params, singleRequest: true, loading: false }),
    getFinanceTransaction: params => api.get('/merchant/transactions', { params, singleRequest: true, loading: false }),
    exportTransactionList: params => api.get(`/merchant/download-transactions`, { params, singleRequest: true, responseType: 'blob' }),
}
